const CrossIcon = ({ color = "var(--pink)", size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.7882 18.7886C16.9879 20.589 14.5461 21.6004 12 21.6004C9.45395 21.6004 7.01215 20.589 5.2118 18.7886C3.41145 16.9883 2.40002 14.5465 2.40002 12.0004C2.40002 9.45431 3.41145 7.01251 5.2118 5.21217C7.01215 3.41182 9.45395 2.40039 12 2.40039C14.5461 2.40039 16.9879 3.41182 18.7882 5.21217C20.5886 7.01251 21.6 9.45431 21.6 12.0004C21.6 14.5465 20.5886 16.9883 18.7882 18.7886ZM9.70711 8.29338C9.31658 7.90286 8.68342 7.90286 8.29289 8.29338C7.90237 8.68391 7.90237 9.31707 8.29289 9.70759L10.5858 12.0005L8.29289 14.2934C7.90237 14.6839 7.90237 15.3171 8.29289 15.7076C8.68342 16.0981 9.31658 16.0981 9.70711 15.7076L12 13.4147L14.2929 15.7076C14.6834 16.0981 15.3166 16.0981 15.7071 15.7076C16.0976 15.3171 16.0976 14.6839 15.7071 14.2934L13.4142 12.0005L15.7071 9.70759C16.0976 9.31707 16.0976 8.68391 15.7071 8.29338C15.3166 7.90286 14.6834 7.90286 14.2929 8.29338L12 10.5863L9.70711 8.29338Z"
        fill={color}
      />
    </svg>
  );
};

export default CrossIcon;
